// extracted by mini-css-extract-plugin
export default {"productDescription":"dba-z","featuredDescription":"eba-z","description":"fba-z","more":"gba-z","descriptionSku":"hba-z"};